<script lang="ts">
  import { browser } from '$app/environment';
  import { goto, invalidate, invalidateAll } from '$app/navigation';
  import { page } from '$app/stores';
  import { lastAuthState } from '$utils/auth';
  import { createMenu } from 'svelte-headlessui';
  import Transition from 'svelte-transition';

  const menu = createMenu({ label: 'Actions' });

  async function logout() {
    fetch('/api/auth/logout', {
      method: 'POST'
    }).then(() => {
      lastAuthState.set(false);
      invalidateAll();
    });
  }

  async function gotoLogin() {
    if (browser) goto('/login');
  }

  async function billing() {
    if (browser) goto('/billing');
  }

  async function guide() {
    if (browser) {
      window.open('https://guide.betwatch.com', '_blank');
    }
  }

  async function apiKeys() {
    if (browser) goto('/app/account/api');
  }

  const authed = [
    { text: 'Guide', action: guide },
    { text: 'Billing', action: billing },
    { text: 'API Keys', action: apiKeys },
    { text: `Logout`, action: logout }
  ];
  const guest = [
    { text: 'Guide', action: guide },
    { text: `Login or Register`, action: gotoLogin }
  ];
  $: items = $page?.data?.session?.user?.email ? authed : guest;

  $: displayUser = $page?.data?.session?.user?.email;
</script>

<div
  use:menu.button
  class="flex w-full cursor-pointer flex-row items-center border-t border-gray-200 bg-gray-100 p-3 hover:bg-gray-200"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="h-6 w-6 self-center"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </svg>

  {#if !displayUser}
    <div class="flex flex-row place-items-start items-center pl-2">
      <p
        class="flex text-sm font-medium text-gray-700 group-hover:text-gray-900"
      >
        Login / Register
      </p>
    </div>
  {:else}
    <div class="flex flex-1 flex-row place-items-start items-center pl-2">
      <p
        class="flex text-sm font-medium text-gray-700 group-hover:text-gray-900"
      >
        {displayUser}
      </p>
    </div>
  {/if}
</div>
<Transition
  show={$menu.expanded}
  enter="transition ease-out duration-100"
  enterFrom="transform opacity-0 scale-95"
  enterTo="transform opacity-100 scale-100"
  leave="transition ease-in duration-75"
  leaveFrom="transform opacity-100 scale-100"
  leaveTo="transform opacity-0 scale-95"
>
  <div
    use:menu.items
    class="absolute bottom-0 z-40 mb-12 w-full divide-y divide-gray-100 rounded-md bg-white p-2 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
  >
    {#each items as item}
      {@const active = $menu.active === item.text}
      <button
        on:click={item.action}
        use:menu.item
        class="group flex w-full items-center rounded-md px-2 py-2 text-sm {active
          ? 'bg-gray-100 text-gray-900'
          : 'text-gray-900'}"
      >
        <!-- <svelte:component this={option.icon} class="w-5 h-5 mr-2" {active} /> -->
        {item.text}
      </button>
    {/each}
  </div>
</Transition>
